'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _signupOrLoginButton = require('./signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO Title Section',

    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        subtitle: _react2['default'].PropTypes.string.isRequired,
        buttonText: _react2['default'].PropTypes.string.isRequired,
        buttonUrl: _react2['default'].PropTypes.string
    },

    render: function render() {
        var props = this.props;
        var signupOrLoginButtonProps = {
            buttonText: props.signupButtonText,
            buttonUrl: props.signupButtonUrl
        };
        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'm-marketing-page--title-section row text-center l-padding-t-60 l-padding-b-10'
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx('h1', {
            className: 'm-marketing-page--title'
        }, void 0, props.title), _jsx('h4', {
            className: 'm-marketing-page--subtitle downsize'
        }, void 0, props.subtitle))), _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, signupOrLoginButtonProps, props)));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/title-section.jsx
 ** module id = 811
 ** module chunks = 0
 **/